require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;


/*****************
 ** WEBPACK FOOTER
 ** /Users/prosciutto/Works/Slam/~/core-js/fn/regexp/escape.js
 ** module id = 246
 ** module chunks = 0
 **/